import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logo } from "../../constants";

const Header = () => {
	const [category, showcategory] = useState(false);
	function showcard() {
		showcategory(true);
	}
	function hidecard() {
		showcategory(false);
	}
	const location = useLocation();
	return (
		<>
			{/* <!-- feedback modals ends here --> */}
			<div
				className="modal fade rev"
				id="staticBackdrop"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							{/* <span aria-hidden="true">&times;</span> */}
						</button>
						<div className="modal-body text-center">
							<h4>Feedback</h4>
							<form action="">
								<div className="form-group">
									<textarea
										name=""
										placeholder="Lorem Ipsum"
										className="form-control"
										id=""
										cols="30"
										rows="5"
									></textarea>
								</div>
								<div className="form-group mt-3">
									<button className="btn form-control">Send Feedback</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			{/* <!-- feedback modals ends here --> */}
			<header id="header">
				<div className="top-header-wrapper">
					<div className="container-fluid">
						<div className="row align-items-center">
							<div className="col-lg-2">
								<div className="logo-wrapper">
									<Link to="/">
										<img src={logo} className="img-fluid" alt="" />
									</Link>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="search-wrapper">
									<select name="categorys" id="">
										<option defaultValue="ALL CATEGORIES" selected disabled>
											ALL CATEGORIES
										</option>
									</select>
									<div className="search-bar-wrapper">
										<input
											type="search"
											className="form-control"
											placeholder="I’m searching for..."
										/>
									</div>
								</div>
							</div>
							<div className="col-lg-4">
								<div className="header-menu-icons-wrapper">
									<ul>
										<li className="phone-no">
											<h6>8800 332 65-66</h6>
											<span>Support 24/7</span>
										</li>
										<li className="icon-list">
											<a href="/sign-in">
												{/* <i className="fa fa-user" aria-hidden="true"></i> */}
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="27"
													height="27"
													viewBox="0 0 27 27"
												>
													<g id="person-dash" transform="translate(0 -4.5)">
														<path
															id="Path_20"
															data-name="Path 20"
															d="M24.75,31.5A2.2,2.2,0,0,0,27,29.25c0-2.25-2.25-9-13.5-9S0,27,0,29.25A2.2,2.2,0,0,0,2.25,31.5ZM2.261,29.376v0ZM2.3,29.25H24.7l.032-.005.018,0A6.007,6.007,0,0,0,22.879,25.5c-1.468-1.466-4.229-3-9.379-3s-7.911,1.53-9.378,3A6.025,6.025,0,0,0,2.25,29.241l.049.009Zm22.442.126v0ZM13.5,15.75A4.5,4.5,0,1,0,9,11.25,4.5,4.5,0,0,0,13.5,15.75Zm6.75-4.5A6.75,6.75,0,1,1,13.5,4.5,6.75,6.75,0,0,1,20.25,11.25Z"
															fillRule="evenodd"
														/>
													</g>
												</svg>
											</a>
										</li>
										<li className="icon-list">
											<a href="/MyWishlist">
												{/* <i className="fa fa-heart-o"></i> */}
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="26.328"
													height="23.258"
													viewBox="0 0 26.328 23.258"
												>
													<path
														id="Icon_feather-heart"
														data-name="Icon feather-heart"
														d="M24.5,6.35a6.322,6.322,0,0,0-8.943,0L14.337,7.569,13.118,6.35a6.324,6.324,0,1,0-8.943,8.943l1.218,1.218,8.943,8.943,8.943-8.943L24.5,15.293a6.322,6.322,0,0,0,0-8.943Z"
														transform="translate(-1.173 -3.347)"
														fill="none"
														stroke="#000"
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth="2.3"
													/>
												</svg>

												<span className="count"></span>
											</a>
										</li>
										<li className="icon-list">
											<a href="/Product-cart">
												<div className="shopping-wrapper">
													{/* <i className="fa fa-shopping-cart"></i> */}
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="26.53"
														height="25.429"
														viewBox="0 0 26.53 25.429"
													>
														<g
															id="Icon_feather-shopping-cart"
															data-name="Icon feather-shopping-cart"
															transform="translate(-0.35 -0.35)"
														>
															<path
																id="Path_17"
																data-name="Path 17"
																d="M14.2,31.1A1.1,1.1,0,1,1,13.1,30,1.1,1.1,0,0,1,14.2,31.1Z"
																transform="translate(-2.79 -7.574)"
																fill="none"
																stroke="#000"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth="2.3"
															/>
															<path
																id="Path_18"
																data-name="Path 18"
																d="M30.7,31.1A1.1,1.1,0,1,1,29.6,30,1.1,1.1,0,0,1,30.7,31.1Z"
																transform="translate(-7.175 -7.574)"
																fill="none"
																stroke="#000"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth="2.3"
															/>
															<path
																id="Path_19"
																data-name="Path 19"
																d="M1.5,1.5H5.906L8.857,16.248a2.2,2.2,0,0,0,2.2,1.773H21.765a2.2,2.2,0,0,0,2.2-1.773L25.73,7.007H7.007"
																fill="none"
																stroke="#000"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth="2.3"
															/>
														</g>
													</svg>

													<span className="count">12</span>
													<div className="cart-content-wrapper">
														<h6>Your Cart</h6>
														<span>$650.59</span>
													</div>
												</div>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="main-header-wrapper">
					<div className="container-fluid">
						<div className="row">
							<div className="col-lg-2">
								<div className="category-bar-wrapper">
									<button onClick={showcard} className="category-btn">
										Shop By Category
									</button>
									{category == true ? (
										<button className="close" onClick={hidecard}>
											<i className="fa fa-close"></i>
										</button>
									) : null}
								</div>

								{category == true ? (
									<div className="category-list-wrapper">
										<div className="accordion" id="accordionExample">
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingOne">
													<button
														className="accordion-button"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseOne"
														aria-expanded="true"
														aria-controls="collapseOne"
													>
														Clothing
													</button>
												</h2>
												<div
													id="collapseOne"
													className="accordion-collapse collapse show"
													aria-labelledby="headingOne"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Tops</a>{" "}
															</li>
															<li>
																<a href="#">Bottoms</a>
															</li>
															<li>
																<a href="#">Skirts</a>
															</li>
															<li>
																<a href="#">Dresses</a>
															</li>
															<li>
																<a href="#">Shoes</a>
															</li>
															<li>
																<a href="#">Accessories</a>
															</li>
															<li>
																<a href="#">Coats and Jackets</a>
															</li>
															<li>
																<a href="#">Jumpsuits and playsuits</a>
															</li>
															<li>
																<a href="#">Nightwear</a>
															</li>
															<li>
																<a href="#">lingerie</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingTwo">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseTwo"
														aria-expanded="false"
														aria-controls="collapseTwo"
													>
														Food
													</button>
												</h2>
												<div
													id="collapseTwo"
													className="accordion-collapse collapse"
													aria-labelledby="headingTwo"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Chocolate and snacks</a>{" "}
															</li>
															<li>
																<a href="#">Food cupboard</a>
															</li>
															<li>
																<a href="#">Fresh</a>
															</li>
															<li>
																<a href="#">Frozen</a>
															</li>
															<li>
																<a href="#">Drinks</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingThree">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseThree"
														aria-expanded="false"
														aria-controls="collapseThree"
													>
														Bath & Body
													</button>
												</h2>
												<div
													id="collapseThree"
													className="accordion-collapse collapse"
													aria-labelledby="headingThree"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#"> Shampoo and conditioner</a>{" "}
															</li>
															<li>
																<a href="#">Deodorant</a>
															</li>
															<li>
																<a href="#">Bubble bath</a>
															</li>
															<li>
																<a href="#">Body scrub</a>
															</li>
															<li>
																<a href="#">Shower wash</a>
															</li>
															<li>
																<a href="#">Bath salts</a>
															</li>
															<li>
																<a href="#">Bath bombs</a>
															</li>
															<li>
																<a href="#">Bath and shower accessories</a>
															</li>
															<li>
																<a href="#">Lotions and oils</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingFour">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseFour"
														aria-expanded="false"
														aria-controls="collapseFour"
													>
														Health & Beauty
													</button>
												</h2>
												<div
													id="collapseFour"
													className="accordion-collapse collapse"
													aria-labelledby="headingFour"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Skincare</a>{" "}
															</li>
															<li>
																<a href="#">Haircare</a>
															</li>
															<li>
																<a href="#">Cosmetics</a>
															</li>
															<li>
																<a href="#">Beauty accessories</a>
															</li>
															<li>
																<a href="#">Pads, Tampons and cups</a>
															</li>
															<li>
																<a href="#">Sexual health</a>
															</li>
															<li>
																<a href="#">Dental care</a>
															</li>
															<li>
																<a href="#">First aid</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingFive">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseFive"
														aria-expanded="false"
														aria-controls="collapseFive"
													>
														Baby , Child & Parents
													</button>
												</h2>
												<div
													id="collapseFive"
													className="accordion-collapse collapse"
													aria-labelledby="headingFive"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Clothing</a>{" "}
															</li>
															<li>
																<a href="#">Pregnancy and maternity</a>
															</li>
															<li>
																<a href="#">Toys</a>
															</li>
															<li>
																<a href="#">Baby changing & accessories</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingSix">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseSix"
														aria-expanded="false"
														aria-controls="collapseSix"
													>
														Homeware
													</button>
												</h2>
												<div
													id="collapseSix"
													className="accordion-collapse collapse"
													aria-labelledby="headingSix"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Kitchen</a>{" "}
															</li>
															<li>
																<a href="#">Bathroom</a>
															</li>
															<li>
																<a href="#">Outdoors</a>
															</li>
															<li>
																<a href="#">Cleaning</a>
															</li>
															<li>
																<a href="#">Home accessories</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingSeven">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseSeven"
														aria-expanded="false"
														aria-controls="collapseSeven"
													>
														Pets
													</button>
												</h2>
												<div
													id="collapseSeven"
													className="accordion-collapse collapse"
													aria-labelledby="headingSeven"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Pet food/treats</a>{" "}
															</li>
															<li>
																<a href="#">Pet accessories</a>
															</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <div className="accordion-item">
												<h2 className="accordion-header" id="headingEight">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseEight"
														aria-expanded="false"
														aria-controls="collapseEight"
													>
														Pets
													</button>
												</h2>
												<div
													id="collapseEight"
													className="accordion-collapse collapse"
													aria-labelledby="headingEight"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														<ul className="list-wrapper">
															<li>
																<a href="#">Tops</a>{" "}
															</li>
															<li>
																<a href="#">Bottoms</a>
															</li>
															<li>
																<a href="#">Skirts</a>
															</li>
															<li>
																<a href="#">Dresses</a>
															</li>
															<li>
																<a href="#">Shoes</a>
															</li>
															<li>
																<a href="#">Accessories</a>
															</li>
															<li>
																<a href="#">Coats and Jackets</a>
															</li>
															<li>
																<a href="#">Jumpsuits and playsuits</a>
															</li>
															<li>
																<a href="#">Nightwear</a>
															</li>
															<li>
																<a href="#">lingerie</a>
															</li>
														</ul>
													</div>
												</div>
											</div> */}
										</div>
									</div>
								) : (
									""
								)}
							</div>
							<div className="col-lg-6"></div>
							<div className="col-lg-4">
								<div className="menu-items-wrapper">
									<ul>
										<li className="nav-item">
											<a href="/" className="nav-link">
												Home
											</a>
										</li>
										<li className="nav-item">
											<a href="/shop" className="nav-link">
												Shop
											</a>
										</li>
										<li className="nav-item">
											<a href="/about" className="nav-link">
												About
											</a>
										</li>
										<li className="nav-item">
											<a href="/contact" className="nav-link">
												Contact
											</a>
										</li>
										<li className="nav-item">
											<a href="/sign-in" className="nav-link">
												Sign in
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
